"use client";

import React from "react";
import { Image } from "@chakra-ui/react";
import { useColorMode } from '../../components/ui/color-mode';

import LogoBlanco from "../../assets/LogoTextoBlanco.png";
import LogoNegro from "../../assets/LogoTextoNegro.png";

/**
 * ArawaksLogo
 *
 * Decide entre LogoNegro y LogoBlanco basado en colorMode,
 * con soporte para:
 * - invert: intercambia el comportamiento (light->blanco, dark->negro)
 * - variant: "auto" (default), "black", "white" (forzar)
 * - lightSrc/darkSrc: override por ruta si en algún lugar usas otros assets
 * - props extra: se pasan directo a <Image />
 */
export function ArawaksLogo({
  invert = false,
  variant = "auto", // "auto" | "black" | "white"
  modeVariant,      // { light?: "auto"|"black"|"white", dark?: "auto"|"black"|"white" }
  lightSrc,
  darkSrc,
  alt = "Logo",
  ...imageProps
}) {
  const { colorMode } = useColorMode();

  const srcBlack = LogoNegro;
  const srcWhite = LogoBlanco;

  const resolvedLight = lightSrc ?? (invert ? srcWhite : srcBlack);
  const resolvedDark  = darkSrc  ?? (invert ? srcBlack : srcWhite);

  const effectiveVariant =
    modeVariant?.[colorMode] ?? variant;

  const resolvedSrc =
    effectiveVariant === "black"
      ? srcBlack
      : effectiveVariant === "white"
        ? srcWhite
        : colorMode === "light"
          ? resolvedLight
          : resolvedDark;

  return <Image src={resolvedSrc} alt={alt} objectFit="contain" {...imageProps} />;
}